import { render, staticRenderFns } from "./transAcctTForm.vue?vue&type=template&id=15daa126&scoped=true&"
import script from "./transAcctTForm.vue?vue&type=script&lang=js&"
export * from "./transAcctTForm.vue?vue&type=script&lang=js&"
import style0 from "./transAcctTForm.vue?vue&type=style&index=0&id=15daa126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15daa126",
  null
  
)

export default component.exports